import { HttpHeaders, HttpParams } from '@angular/common/http';
import { Pageable } from '@ms/core/components/table/pageable.model';

export function httpParams(page: Pageable) {
    let params = new HttpParams().set('page', page.pageIndex + '').set('size', page.pageSize + '');
    if (page.sort) {
        params = params.set('sort', page.sort);
    }
    return params;
}

export function hideProgress(): HttpHeaders {
    return new HttpHeaders({ 'hide-progress': 'true' });
}

export function originalData(): HttpHeaders {
    return new HttpHeaders({ 'original-data': 'true' });
}

export function logRequest(): HttpHeaders {
    return new HttpHeaders({ 'X-Log-Request': 'true' });
}
